import React, { FC } from 'react';
import classNames from 'classnames';
import BasicImage from '@home/components/BasicImage';
import AgentModeDefaultIcon from '../../../../svg/agent-mode-default-icon.svg';
import AgentCheckIcon from '../../../../svg/agent-collection.svg';
import AgentDemoBetaIcon from '@/pages/aigc/assets/svg/agent-demo-beta.svg';
import { IAgentData } from '../../../types';

interface IAgentListItemProps {
  /** Agent 数据 */
  agent: IAgentData;
  /** 是否选中 */
  isSelected: boolean;
  /** 是否英文 */
  isEN: boolean;
  /** 点击回调 */
  onClick: (agent: IAgentData) => void;
  /** 国际化函数 */
  formatMessage: (descriptor: { id: string; }) => string;
}

/**
 * Agent 列表单行组件（分组/扁平模式复用）
 */
const AgentListItem: FC<IAgentListItemProps> = ({
  agent,
  isSelected,
  isEN,
  onClick,
  formatMessage,
}) => {
  return (
    <div
      className={classNames('dba-agent-selector__item', {
        'dba-agent-selector__item--selected': isSelected,
      })}
      onClick={() => onClick(agent)}
    >
      <div className="dba-agent-selector__item-icon">
        <BasicImage src={agent.icon} errorSrc={AgentModeDefaultIcon} />
      </div>
      <div className="dba-agent-selector__item-content">
        <div className="dba-agent-selector__item-name">
          {isEN ? agent.name : agent.name_cn}
          {agent.isDemo && (
            <img
              src={AgentDemoBetaIcon}
              alt=""
              className="dba-agent-selector__item-demo-badge"
            />
          )}
          {agent.isRecommended && (
            <span className="dba-agent-selector__item-badge">
              {formatMessage({ id: 'dba_collection_selector_recommended' })}
            </span>
          )}
        </div>
        <div className="dba-agent-selector__item-desc">
          {isEN ? agent.description : agent.description_cn}
        </div>
      </div>
      {isSelected && (
        <div className="dba-agent-selector__item-check">
          <img src={AgentCheckIcon} alt="" />
        </div>
      )}
    </div>
  );
};

export default AgentListItem;
